import React from "react";
import { Link, useParams } from "react-router-dom";
import { Panel, PanelHeader, PanelBody } from "../../components/panel/panel.jsx";
import DatePicker from "react-datepicker";
import DateTime from "react-datetime";
import moment from "moment";
import Tooltip from "rc-tooltip";
import Slider from "rc-slider";
import "rc-slider/assets/index.css";
import "react-datetime/css/react-datetime.css";
import "react-datepicker/dist/react-datepicker.css";
import Joi from "joi";
import Form from "../../common/form.jsx";
import Select from "react-select";
import http from "../../services/httpService";
import auth from "../../services/authservice";
import { saveTicket, getTicket } from "./../../services/tickets";
import { getReception } from "./../../services/receptions";
import { getSupervisor } from "./../../services/supervisors";
import { getQESHOfficer } from "./../../services/qeshofficers";
import { getQESHSupervisor } from "./../../services/qeshsupervisors";
import { getOperator } from "./../../services/operators";
import { getTicketCategories } from "./../../services/ticketcategories.js"; // Import the new service
import withRouter from "../../common/withRouter.jsx";
import { connect } from 'react-redux';
import { loadCurrentUser } from '../../store/users';
import Editor from "../../components/common/Editor"

const apiUrl = process.env.REACT_APP_API_URL;
const createSliderWithTooltip = Slider.createSliderWithTooltip;
const Handle = Slider.Handle;

class Ticket extends Form {
	async componentDidMount() {
    document.title = "Add Ticket";    
  }
	constructor(props) {
		super(props);

		var maxYesterday = "";
		var minYesterday = DateTime.moment().subtract(1, "day");

		this.minDateRange = (current) => {
			return current.isAfter(minYesterday);
		};
		this.maxDateRange = (current) => {
			return current.isAfter(maxYesterday);
		};
		this.minDateChange = (value) => {
			this.setState({
				maxDateDisabled: false,
			});
			maxYesterday = value;
		};

		this.state = {
			maxDateDisabled: true,
			isEditable: true,
			users: [],
			taskCategories: [], // Add state for task categories
			data: {
				user: "",
				name: "",
				narrative: "",
				category: "",
				// businessName: "",
				priority: "",
				participants: [],
				department: "",
				subDepartment: "",
				locations: "",
				ticketNo: this.makeTicketNo(),
				deadline: new Date(),
				documentNo: "",
				field: "",
				note: "",
				review: "",
				subCategory: "",
				tags: "",
				reference: "",
				status: "",
			},
			selectedFile: null,
			errors: {},
		};

		// Remove hardcoded category options
		this.priorityOptions = [
			{ value: "normal", label: "normal" },
			{ value: "low", label: "low" },
			{ value: "high", label: "high" },
			{ value: "urgent", label: "urgent" },
		];

		this.statusOptions = [
			{ value: "in progress", label: "In Progress" },
			{ value: "pending", label: "Pending" },
			{ value: "new", label: "New" },
			{ value: "archive", label: "Archive" },
		];

		this.handleSlider = (props) => {
			const { value, dragging, index, ...restProps } = props;
			return (
				<Tooltip prefixCls="rc-slider-tooltip" overlay={value} visible={dragging} placement="top" key={index}>
					<Handle value={value} {...restProps} />
				</Tooltip>
			);
		};
		this.handleSubmit = this.handleSubmit.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.onChangeImgHandler = this.onChangeImgHandler.bind(this);
		this.handleMultiChange = this.handleMultiChange.bind(this);
		this.formatSelectOption = this.formatSelectOption.bind(this);
	}

	formatSelectOption = ({ user }) => (
		<div>
			<div style={{ display: "flex", alignItems: "center" }}>
				<div style={{ marginRight: "10px" }}>
					<img width={15} src={user.imageSrc} alt="img here" />
				</div>
				<div>{user.contactName.first + " " + user.contactName.last}</div>
			</div>
		</div>
	);

	handleMultiChange = (name, options) => {
		const data = { ...this.state.data };
		data[name] = options;
		this.setState({ data });
	};

	async populateCategory() {
		try {
			// Fetch task categories from API
			const { data: taskCategories } = await getTicketCategories();
			this.setState({ taskCategories });

			// Create options for dropdown
			this.categoryoptions = taskCategories.map((category) => (
				<option key={category._id} value={category.name}>
					{category.name}
				</option>
			));
		} catch (ex) {
			console.error("Failed to load task categories", ex);
			// Fallback to empty options if API call fails
			this.categoryoptions = <option value="">No categories available</option>;
		}
	}

	async populatePriority() {
		this.priorityoptions = this.priorityOptions.map((option) => (
			<option key={option.label} value={option.value}>
				{option.value}
			</option>
		));
	}

	async populateStatus() {
		this.statusoptions = this.statusOptions.map((option) => (
			<option key={option.label} value={option.value}>
				{option.value}
			</option>
		));
	}

	async populateParticipants() {
		const { data: users } = await http.get(apiUrl + "/users");
		this.setState({ users });
		this.selectParticipants = users.map((user) => {
			return {
				_id: user._id,
				label: user.username,
				value: user._id,
				user: user,
			};
		});
	}

	async populateTicket() {
		try {

			const ticketId = this.props.params.id;
			if (ticketId === "new") return;
			const { data: ticket } = await getTicket(ticketId);
			this.setState({ data: this.mapToViewModel(ticket) });
			console.log(this.state.data);
		} catch (ex) {
			console.log(ex)
			if (ex.response && ex.response.status === 404) this.props?.history?.replace("/error");
		}
	}

	async componentDidMount() {
		await this.populateCategory(); // Load categories first
		await this.populatePriority();
		await this.populateStatus();
		await this.populateParticipants();
		await this.populateTicket();
	}

	schema = Joi.object({
		name: Joi.string(),
		// businessName: Joi.any().optional(),
		narrative: Joi.any().optional(),
		priority: Joi.any().optional(),
		category: Joi.any().optional(),
		department: Joi.any().optional(),
		subDepartment: Joi.any().optional(),
		createdOn: Joi.any().optional(),
		deadline: Joi.any().optional(),
		locations: Joi.any().optional(),
		ticketNo: Joi.any().optional(),
		documentNo: Joi.any().optional(),
		field: Joi.any().optional(),
		tags: Joi.any().optional(),
		reference: Joi.any().optional(),
		status: Joi.any().required(),
	});

	handlecreatedOnChange = (e) => {
		const errors = { ...this.state.errors };
		const data = { ...this.state.data };
		data["createdOn"] = e;
		this.setState({ data });
		console.log(this.state.data);
	};

	handledeadlineChange = (e) => {
		const errors = { ...this.state.errors };
		const data = { ...this.state.data };
		data["deadline"] = e;
		this.setState({ data });
		console.log(this.state.data);
	};

	onChangeImgHandler = (event) => {
		this.setState({ attachments: event.target.files[0] });
		console.log(event.target.files[0]);
	};

	doSubmit = async () => {
		console.log("Submitting data:", this.state.data);
		const user = auth.getProfile();
		const data = { ...this.state.data };
        const currentUser = this.props.currentUser;
      if(currentUser?.role?.name === "Company"){
        data.companyNo = currentUser?.accountNo;
      }
	    else if(currentUser?.role?.name === "Reception"){
		const reception = await getReception(currentUser?.accountNo);
        data.companyNo = reception.companyNo;
      }
	  else if(currentUser?.role?.name === "Supervisor"){
		const supervisor = await getSupervisor(currentUser?.accountNo);
        data.companyNo = supervisor.businessNo;
	  }
	    else if(currentUser?.role?.name === "Operator"){
		const operator = await getOperator(currentUser?.accountNo);
        data.companyNo = operator.businessNo;
	  }
	      else if(currentUser?.role?.name === "QESHOfficer"){
		const operator = await getQESHOfficer(currentUser?.accountNo);
        data.companyNo = operator.companyNo;
	  }
	  else if(currentUser?.role?.name === "QESHSupervisor"){
		const operator = await getQESHSupervisor(currentUser?.accountNo);
        data.companyNo = operator.companyNo;
	  }

		if (this.props.params.id === "new") data.user = user?._id;
		else data.user = data?.user?._id
		// data.businessName = user.role;

		// Transform participants array to only include _id values
		if (data.participants && Array.isArray(data.participants)) {
			data.participants = data.participants.map(
				(participant) => participant._id || participant
			);
		}

		try {
			console.log("Final data to save:", data);
			await saveTicket(data, this.state.attachments);
			if (this.props.navigate) {
				this.props.navigate("/ticket/tickets");
			}
			else if (this.props.history) {
				this.props.history.push("/ticket/tickets");
			}
		} catch (ex) {
			console.error("Error saving ticket:", ex);
			if (ex.response) {
				const errors = { ...this.state.errors };
				errors.status = ex.response.data;
				this.setState({ errors });

				// Optional: Show error message to user
				alert("Failed to save ticket. Please check the form and try again.");
			}
		}
	};

	makeTicketNo() {
		let ticketNumber = "TK-";
		const possible = "ABCDEFGHIJKLMNPQRSTUVWXYZ2356789";
		for (let i = 0; i <= 6; i++) ticketNumber += possible.charAt(Math.floor(Math.random() * possible.length));
		return ticketNumber;
	}

	mapToViewModel(ticket) {
		return {
			_id: ticket._id,
			user: ticket.user,
			name: ticket.name,
			narrative: ticket.narrative,
			category: ticket.category,
			// businessName: ticket.businessName,
			participants: ticket.participants,
			priority: ticket.priority,
			department: ticket.department,
			subDepartment: ticket.subDepartment,
			locations: ticket.locations,
			ticketNo: ticket.ticketNo,
			createdOn: new Date(ticket.createdOn),
			deadline: new Date(ticket.deadline),
			documentNo: ticket.documentNo,
			field: ticket.field,
			note: ticket.note,
			review: ticket.review,
			subCategory: ticket.subCategory,
			tags: ticket.tags,
			reference: ticket.reference,
			status: ticket.status,
		};
	}

	render() {
		const { data, errors } = this.state;
		return (
			<React.Fragment>
				<div>
					<ol className="breadcrumb float-xl-right">
						<li className="breadcrumb-item">
							<Link to="/">Home</Link>
						</li>
						<li className="breadcrumb-item">
							<Link to="/ticket/tickets">Tickets</Link>
						</li>
						<li className="breadcrumb-item active">Add Ticket</li>
					</ol>
					<h1 className="page-header">
						Add Ticket <small>Ticket-registration-form</small>
					</h1>

					<div className="row">
						<div className="col-xl-10">
							<Panel>
								<PanelHeader>Add Ticket</PanelHeader>
								<PanelBody className="panel-form">
									<form className="form-horizontal form-bordered" onSubmit={this.handleSubmit}>
										{this.renderInput(
											"name",
											"Name of ticket",
											"text",
											"Enter Name/Title/subject for ticket"
										)}

										{/* Participants Dropdown with Avatar */}
										<div className="form-group row">
											<label className="col-lg-4 col-form-label">
												Participants
											</label>
											<div className="col-lg-8">
												<Select
													isDisabled={!this.state.isEditable}
													isMulti
													name="participants"
													options={this.selectParticipants}
													formatOptionLabel={this.formatSelectOption}
													placeholder={"Select Participants..."}
													value={this.selectParticipants?.filter((opt) => {
														let participantIDs = data.participants?.map(
															(el) => el._id
														);
														return participantIDs?.includes(opt.value);
													})}
													onChange={(e) => this.handleMultiChange("participants", e)}
												/>
											</div>
										</div>

										{this.renderTextarea("narrative", "Narrative", "Enter your story...")}

										<div className="form-group row">
											<label className="col-lg-4 col-form-label" htmlFor="priority">Priority
											</label>
											<div className="col-lg-8">
												<select
													name="priority"
													id="priority"
													value={data.priority}
													onChange={this.handleChange}
													className="form-control"
												>
													<option value="">Select Priority</option>
													{this.priorityoptions}
												</select>
											</div>
											{errors.priority && <div className="alert alert-danger">{errors.priority}</div>}
										</div>

										<div className="form-group row">
											<label className="col-lg-4 col-form-label" htmlFor="category">Category
											</label>
											<div className="col-lg-8">
												<select
													name="category"
													id="category"
													value={data.category}
													onChange={this.handleChange}
													className="form-control"
												>
													<option value="">Select Category</option>
													{this.categoryoptions}
												</select>
											</div>
											{errors.category && <div className="alert alert-danger">{errors.category}</div>}
										</div>

										{this.renderInput("subCategory", "Sub-Category", "text", "Enter Sub-category")}
										{this.renderInput("department", "Department", "text", "Enter Department")}
										{this.renderInput("subDepartment", "Sub-Department", "text", "Enter Sub-department")}
										{this.renderInput("locations", "Locations", "text", "Enter Locations")}
										{this.renderInput("documentNo", "DocumentNo", "text", "Enter DocumentNo")}
										{this.renderInput("field", "field", "text", "Enter field")}
										{this.renderInput("tags", "Tags", "text", "Enter Tags")}
										{this.renderInput("review", "review", "text", "Enter review")}
										{this.renderInput("reference", "References", "text", "Enter References")}
										{this.renderTextarea("note", "Note", "Enter Note")}

										<div className="form-group row">
											<label className="col-lg-4 col-form-label" htmlFor="deadline">
												Deadline
											</label>
											<div className="col-lg-8">
												<DatePicker
													onChange={this.handledeadlineChange}
													id={data.deadline}
													value={data.deadline}
													selected={data.deadline}
													inputProps={{ placeholder: "Datepicker" }}
													className="form-control"
												/>
												{errors.deadline && <div className="alert alert-danger">{errors.deadline}</div>}
											</div>
										</div>

										<div className="form-group row">
											<label className="col-lg-4 col-form-label" htmlFor="status">
												Status
											</label>
											<div className="col-lg-8">
												<select
													name="status"
													id="status"
													value={data.status}
													onChange={this.handleChange}
													className="form-control"
												>
													<option value="">Select Status</option>
													{this.statusoptions}
												</select>
											</div>
											{errors.status && <div className="alert alert-danger">{errors.status}</div>}
										</div>

										<div className="form-group row">
											<label className="col-lg-4 col-form-label" htmlFor="imageSrc">Attachments</label>
											<div className="col-lg-8">
												<div className="row row-space-10">
													<input type="file" id="imageSrc" name="imageSrc"
														className="form-control-file m-b-5"
														onChange={this.onChangeImgHandler}
													/>
													{errors.imageSrc && (
														<div className="alert alert-danger">
															{errors.imageSrc}
														</div>
													)}
												</div>
											</div>
										</div>

										<div className="form-group row">
											<div className="col-lg-8">
												<button
													type="submit"
													disabled={this.validate}
													className="btn btn-primary width-65"
												>
													Submit
												</button>
											</div>
										</div>
									</form>
								</PanelBody>
							</Panel>
						</div>
					</div>
				</div>
			</React.Fragment>
		);
	}
}

//export default withRouter(Ticket);
const mapStateToProps = (state) => ({
  currentUser: state.entities.users.currentUser,
});
const mapDispatchToProps = (dispatch) => ({
  loadCurrentUser: (id) => dispatch(loadCurrentUser(id)),
});
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Ticket));
